'use client';

import { AuthenticationStatus } from '@/enums/authentication-status';
import { MobileAuthenticationStatusType } from '@/hooks/is-mobile';
import Image from 'next/image';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner';


type MobileAuthGuardComponentProps = {
  status: MobileAuthenticationStatusType;
};

export const MobileAuthGuardComponent = ({ status }: MobileAuthGuardComponentProps): React.JSX.Element => {
  return (
    <div className="fixed inset-0 z-300 flex flex-col gap-6 items-center justify-center text-center p-4">
      <Image alt="Cinemark logo"
        className="max-w-[600px]"
        height={42}
        src="/img/cinemarkLogo.png"
        width={301}
      />

      {status !== AuthenticationStatus.UNAUTHENTICATED &&
        <>
          <h2 data-test="authenticating-header">We're authenticating you, give us a moment</h2>
          <LoadingSpinnerComponent center="within"
            className="!my-0"
          />
        </>
      }

      {status === AuthenticationStatus.UNAUTHENTICATED &&
        <>
          <h2 data-test="unauthenticated-header">Something went wrong...</h2>
          <p data-test="unauthenticated-help-text">Please close this view and try again.</p>
        </>
      }
    </div>
  );
};
